import React from 'react';
import { Button } from 'react-bootstrap';
import { MdOutlineTableRestaurant } from 'react-icons/md';
import { FaPlus } from 'react-icons/fa6';
import { VIEW_MODES, type ViewMode } from '../../utils';
import './SalesEmptyState.scss';

interface SalesEmptyStateProps {
  isPedidosMode: boolean;
  salones: any;
  setViewMode: (mode: ViewMode) => void;
}

const SalesEmptyState: React.FC<SalesEmptyStateProps> = ({
  isPedidosMode,
  salones,
  setViewMode
}) => {
  // Check if user is in map/list view (not pedidos mode) and needs to select a mesa or group
  const needsTableSelection = !isPedidosMode;
  
  // Check if there's a virtual mesa available in any salon
  const hasVirtualMesa = salones?.some((salon: any) => 
    salon.mesas?.some((mesa: any) => mesa.is_virtual === true)
  );

  return (
    <div className="sales-panel">
      <div className="sales-empty-state">
        <div className="empty-icon">
          {isPedidosMode ? '📦' : <MdOutlineTableRestaurant size={64} />}
        </div>
        <div className="empty-message">
          {isPedidosMode ? 'Selecciona un pedido' : 'Selecciona una mesa o grupo'}
        </div>
        <div className="empty-description">
          {isPedidosMode 
            ? 'Haz clic en un pedido para ver los detalles'
            : needsTableSelection && !hasVirtualMesa
              ? 'Haz clic en una mesa o grupo del mapa para comenzar a tomar pedidos'
              : 'Haz clic en una mesa, grupo, o la mesa virtual (MV) para tomar pedidos'
          }
        </div>
        {isPedidosMode && (
          <Button
            variant="none"
            className="empty-state-cta"
            onClick={() => setViewMode(VIEW_MODES.CREATE_PEDIDO)}
          >
            <FaPlus /> Crear Pedido
          </Button>
        )}
      </div>
    </div>
  );
};

export default SalesEmptyState;
